import {connect} from "redux-vue";
import WelcomeSlide from "./slides/WelcomeSlide";
import WhatToDoSlide from "./slides/WhatToDoSlide";
import CaseStudySlide from "./slides/CaseStudySlide";
import IntroductionSlide from "./slides/IntroductionSlide";
import ResourcesSlide from "./slides/ResourcesSlide";
import ConclusionSlide from "./slides/ConclusionSlide";
import TakeActionSlide from "./slides/TakeActionSlide";
import ActionModal from "./modals/ActionModal";
import ActionsMessageModal from "./modals/ActionMessageModal";
import StakeholdersSlide from "./slides/StakeholdersSlide";
import LocationModal from "./modals/LocationModal";
import CompletedModal from "./modals/CompletedModal";
import SummarySlide from "./slides/SummarySlide";
import {precacheImages, resetScrollConfig} from "./helpers/tools";

const Simulation = {
  name: 'ChangeManagementSimulation',
  props: ['app', 'activity'],

  watch: {
    'app.slide'() {
      resetScrollConfig();
    },
    'app.completed'(n) {
      (n)?window.postMessage('activityComplete'):null
    }
  },

  created() {
    precacheImages();
  },

  render (h) {
    const slides = {
      'welcome': WelcomeSlide,
      'introduction': IntroductionSlide,
      'what-to-do': WhatToDoSlide,
      'case-study': CaseStudySlide,
      'stakeholders': StakeholdersSlide,
      'take-action': TakeActionSlide,
      'resources': ResourcesSlide,
      'summary': SummarySlide,
      'conclusion': ConclusionSlide,
    };
    const Slide = slides[this.app.slide];
    return (
      <div class="relative">
        <portal to="modals">
          <ActionModal/>
          <ActionsMessageModal/>
          <LocationModal/>
          <CompletedModal/>
        </portal>
        <Slide/>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    app: state.simulation.app,
  };
}

function mapActionToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapActionToProps)(Simulation);
